// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const RAGoalSummary = require('./RAGoalSummary');

class RAGoalModifyPlanSummary extends React.Component {
    render() {
        const { immGlobalPositionPortfolio } = this.props;
        const investmentAmount = immGlobalPositionPortfolio.getIn(
            ['keyFigures', 'investedAmount'],
            '0',
        );
        const goalInformation = immGlobalPositionPortfolio.get(
            'goalInformation',
        );
        const recurringTransfers = immGlobalPositionPortfolio.get(
            'recurringTransfers',
        );
        const goalName = goalInformation.get('name');
        const goalEndOfDate = goalInformation.get('goalDate');
        const goalAmount = goalInformation.get('goalAmount');
        const iconType = goalInformation.get('goalType');
        const hasRegularContributionSummary =
            !!recurringTransfers && recurringTransfers.get('amount');
        let regularContributionsAmount = false;
        let periodicity = false;
        if (hasRegularContributionSummary) {
            regularContributionsAmount = recurringTransfers.get('amount');
            periodicity = parseInt(recurringTransfers.get('recurringCode'));
        }

        return (
            <RAGoalSummary
                iconType={iconType}
                goalName={goalName}
                goalEndOfDate={goalEndOfDate}
                investmentAmount={investmentAmount}
                goalAmount={goalAmount}
                regularContributionsAmount={regularContributionsAmount}
                periodicity={periodicity}
            />
        );
    }
}

RAGoalModifyPlanSummary.propTypes = {
    immGlobalPositionPortfolio: PropTypes.object.isRequired,
};

module.exports = RAGoalModifyPlanSummary;
